import { LoginFormClasses, TextInput } from 'react-admin';

import { Button, CardContent, CircularProgress } from '@mui/material';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { Form, required, useLogin, useNotify, useSafeSetState, useTranslate } from 'ra-core';

const PREFIX = 'RaLoginForm';

/*
 * COPIED DIRECTLY FROM the react-admin CODEBASE, with a few modifications:
 * - "Use the word Login" instead of Sign-in (see 'return' section of this component)
 * Because the code is almost an exact copy of what is in react-admin,
 * no point in worrying about unit testing
 **/
export const LoginForm = (props: LoginFormProps) => {
  const { redirectTo, className } = props;
  const [loading, setLoading] = useSafeSetState(false);
  const login = useLogin();
  const translate = useTranslate();
  const notify = useNotify();

  const submit = (values: FieldValues): void => {
    setLoading(true);
    login(values, redirectTo)
      .then(() => {
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        notify(
          typeof error === 'string'
            ? error
            : typeof error === 'undefined' || !error.message
            ? 'ra.auth.sign_in_error'
            : error.message,
          {
            type: 'warning',
            messageArgs: {
              _: typeof error === 'string' ? error : error && error.message ? error.message : undefined,
            },
          }
        );
      });
  };

  return (
    // @ts-ignore copied directly from React-Admin - not sure why it's showing an IDE error
    <StyledForm onSubmit={submit} mode="onChange" noValidate className={className}>
      <CardContent className={LoginFormClasses.content}>
        <TextInput source="username" label={translate('ra.auth.username')} validate={required()} fullWidth />
        <TextInput
          source="password"
          label={translate('ra.auth.password')}
          type="password"
          autoComplete="current-password"
          validate={required()}
          fullWidth
        />

        <Button
          variant="contained"
          type="submit"
          color="primary"
          disabled={loading}
          fullWidth
          className={LoginFormClasses.button}>
          {loading ? <CircularProgress className={LoginFormClasses.icon} size={19} thickness={3} /> : 'Login'}
        </Button>
      </CardContent>
    </StyledForm>
  );
};

const StyledForm = styled(Form, {
  name: PREFIX,
  overridesResolver: (props, styles) => styles.root,
})(({ theme }) => ({
  [`& .${LoginFormClasses.content}`]: {
    width: 300,
  },
  [`& .${LoginFormClasses.button}`]: {
    marginTop: theme.spacing(2),
  },
  [`& .${LoginFormClasses.icon}`]: {
    margin: theme.spacing(0.3),
  },
}));

export interface LoginFormProps {
  redirectTo?: string;
  className?: string;
}

interface FieldValues {
  username: string;
  password: string;
}

LoginForm.propTypes = {
  redirectTo: PropTypes.string,
};
